// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAp1Hfq7vTj4dmmRi2hDVh_TuKUQSPDMUk",
  authDomain: "seoaudit2-2nd.firebaseapp.com",
  projectId: "seoaudit2-2nd",
  storageBucket: "seoaudit2-2nd.firebasestorage.app",
  messagingSenderId: "976506019831",
  appId: "1:976506019831:web:230f8b527d87bac0f498f2"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;